import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Info } from 'lucide-react';
import Tooltip from '../../../components/ui/Tooltip';
import DashboardCard from './DashboardCard';
import RowAvatar from './RowAvatar';
import { NumTable, StatusChip } from '../styles';
import { CARD_IDS } from '../constants';
import { formatNumber } from '../format';

const Person = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

const InfoIcon = styled.span`
  display: inline-flex;
  color: #A0A8B4;
  cursor: help;
`;

// Devamsızlık Risk Listesi (Bradford, son 12 ay): puan = S² × D; ilk 10. İşe giriş öncesi devamsızlık sayılmaz.
export default function BradfordCard({ slice }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const items = slice.data?.items || [];

  const info = (
    <span data-export-exclude>
      <Tooltip text={t('attendanceDashboard.bradford.info')}>
        <InfoIcon aria-label={t('attendanceDashboard.bradford.info')}><Info size={15} /></InfoIcon>
      </Tooltip>
    </span>
  );

  return (
    <DashboardCard
      cardKey="bradford"
      title={t('attendanceDashboard.bradford.title')}
      meta={t('attendanceDashboard.bradford.meta')}
      span={6}
      spanMd={6}
      slice={slice}
      empty={items.length === 0}
      emptyText={t('attendanceDashboard.bradford.empty')}
      domId={CARD_IDS.bradford}
      headerExtra={info}
    >
      <NumTable>
        <thead>
          <tr>
            <th>{t('attendanceDashboard.bradford.columns.employee')}</th>
            <th className="n">{t('attendanceDashboard.bradford.columns.spells')}</th>
            <th className="n">{t('attendanceDashboard.bradford.columns.days')}</th>
            <th className="n">{t('attendanceDashboard.bradford.columns.score')}</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.userId} data-person={item.userId}>
              <td>
                <Person>
                  <RowAvatar src={item.profilePicture} name={item.fullName || t('attendanceDashboard.unknownPerson')} size={22} />
                  <span>
                    {item.fullName || t('attendanceDashboard.unknownPerson')}
                    {item.employeeStatusName ? <StatusChip>{item.employeeStatusName}</StatusChip> : null}
                  </span>
                </Person>
              </td>
              <td className="n">{formatNumber(item.spells, lang)}</td>
              <td className="n">{formatNumber(item.days, lang)}</td>
              <td className="n" style={{ fontWeight: 700 }}>{formatNumber(item.score, lang)}</td>
            </tr>
          ))}
        </tbody>
      </NumTable>
    </DashboardCard>
  );
}
